import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import {
    IPrescriptionData,
    initialState,
    ILensPrescriptionAction,
} from "./initialState";
export const useLensPrescriptionStore = create<ILensPrescriptionAction>()(
    devtools(
        persist(
            (set, get) => ({
                ...initialState,
                getPrescription: (
                    value: Partial<IPrescriptionData>,
                    rx: string,
                    attachment: string,
                    lens: number = 1,
                ) => {
                    set({
                        prescription: { ...get().prescription, ...value },
                        rx,
                        attachment,
                        isoldThan40: oldThan40(value),
                        isAddRecommend: addRecommend(value),
                        isTypeRecommend: typeRecommend(value),
                        showEdit: false,
                    });
                },
                initPrescription: () => {
                    set({
                        prescription: {
                            od_sph: "",
                            od_cyl: "",
                            os_sph: "",
                            os_cyl: "",
                        },
                        rx: "",
                        attachment: "",
                        isoldThan40: false,
                        isAddRecommend: false,
                        isTypeRecommend: false,
                        showEdit: true,
                    });
                },
                showEditFunc: () => {
                    set({ prescription: {}, showEdit: true });
                },
            }),
            {
                name: "login-storage",
                storage: createJSONStorage(() => sessionStorage),
            },
        ),
        {
            name: "login-store",
        },
    ),
);

function oldThan40(prescription: Partial<IPrescriptionData>) {
    const birth = parseFloat((prescription.birth_year ?? "").toString());
    const nowYear = new Date().getFullYear();
    return !birth ? false : nowYear - birth >= 40;
}

//是否推荐双光
function addRecommend(prescription: Partial<IPrescriptionData>) {
    const add = parseFloat((prescription.add ?? "").toString());
    const birth = parseFloat((prescription.birth_year ?? "").toString());
    const nowYear = new Date().getFullYear();
    // 没填判断小于40岁

    return !!(!birth ? false : nowYear - birth >= 40 && add);
}

//是否推荐蓝光
function typeRecommend(prescription: Partial<IPrescriptionData>) {
    const birth = parseFloat((prescription.birth_year ?? "").toString());
    const nowYear = new Date().getFullYear();
    const oldThan40 = !birth ? false : nowYear - birth >= 40;
    //蓝光推荐条件：非图片处方，填写生日且小于40岁
    return !oldThan40 && !prescription.image_file_url;
}
